(function () {
    'use strict';

    angular.module('ib-basket-module')
        .service('ShoppingBasketViewModel', ShoppingBasketViewModel);

    ShoppingBasketViewModel.$inject = ['OthersFeesViewModel', 'CurrencyService', 'ibBasketSectionTransformer', '$rootScope', 'localStorageService'];

    function ShoppingBasketViewModel (OthersFeesViewModel, CurrencyService, ibBasketSectionTransformer, $rootScope, localStorageService) {
        const self = this;
        self.updateOthersFee = updateOthersFee;
        self.calculateAllBasket = calculateAllBasket;
        self.updateFlexibilization = updateFlexibilization;
        self.updateUpgrading = updateUpgrading;
        self.updatePendingPaymentItems = updatePendingPaymentItems;
        self.updateBasketPriority = updateBasketPriority;

        function updateOthersFee (headerModel, type, fee) {
            let info = {};
            if (headerModel) {
                if (fee) {
                    OthersFeesViewModel.deleteInfo(headerModel.shoppingBasket.othersModel, type, headerModel.shoppingBasket.currency);
                    info = OthersFeesViewModel.getOtherInfo(fee, type, headerModel.shoppingBasket.currency);
                    OthersFeesViewModel.deleteInfo(headerModel.shoppingBasket.othersModel, info.type, headerModel.shoppingBasket.currency);
                    if (info.total >= 0 || info.total < 0) {
                        headerModel.shoppingBasket.othersModel.hasElements = true;
                        headerModel.shoppingBasket.othersModel.others.push(info);
                    }
                    OthersFeesViewModel.updateInfo(headerModel.shoppingBasket.othersModel, headerModel.shoppingBasket.currency);
                } else {
                    if (type) {
                        OthersFeesViewModel.deleteInfo(headerModel.shoppingBasket.othersModel, type, headerModel.shoppingBasket.currency);
                        OthersFeesViewModel.updateInfo(headerModel.shoppingBasket.othersModel, headerModel.shoppingBasket.currency);
                    } else {
                        headerModel.shoppingBasket.othersModel = OthersFeesViewModel.getOthersViewModel(headerModel.shoppingBasket.currency);
                    }
                }
                calculateAllBasket(headerModel.shoppingBasket);
            }
        }

        function updateFlexibilization (headerModel, flexInfo) {
            headerModel.shoppingBasket.flexibilization = ibBasketSectionTransformer.setInfoAncillarie(flexInfo);

            calculateAllBasket(headerModel.shoppingBasket);
        }

        function updateBasketPriority (headerModel, priorityInfo) {
            headerModel.shoppingBasket.priorityBoarding = ibBasketSectionTransformer.setPriorityInfoAncillarie(priorityInfo);
            calculateAllBasket(headerModel.shoppingBasket);
        }

        function updateUpgrading (headerModel, upgrading) {
            headerModel.shoppingBasket.upgrading = upgrading;
            calculateAllBasket(headerModel.shoppingBasket);
        }

        function updatePendingPaymentItems (headerModel, seats, upgrading) {
            let i;
            for (i = 0; i < seats.length; i++) {
                headerModel.shoppingBasket.seats.segments.push(seats[i]);
            }
            if(seats.length > 0) {
                headerModel.shoppingBasket.seats.hasSeats = true;
                headerModel.shoppingBasket.seats.total = calculateSubTotalSeats(headerModel.shoppingBasket.seats);
                headerModel.shoppingBasket.seats.total.totalFormatted = CurrencyService.formatPrice(headerModel.shoppingBasket.currency, headerModel.shoppingBasket.seats.total.total, true);
            }
            if(upgrading && upgrading.upgradingTrips && upgrading.upgradingTrips.length > 0) {
                headerModel.shoppingBasket.upgrading.hasUpgrading = true;
                headerModel.shoppingBasket.upgrading.total = upgrading.total;
                headerModel.shoppingBasket.upgrading.totalFormatted = CurrencyService.formatPrice(headerModel.shoppingBasket.currency, upgrading.total, true);
                headerModel.shoppingBasket.upgrading.segments = generateSegmentsUpgrading(upgrading.upgradingTrips);
            }
            $rootScope.$broadcast('updatePendingItems');
            calculateAllBasket(headerModel.shoppingBasket);
        }

        function generateSegmentsUpgrading (upgradingTrips) {
            const segments = [];
            angular.forEach(upgradingTrips, (segment) => {
                segments.push(segment);
            });
            return segments;
        }

        function calculateSubTotalSeats (seats) {
            let subTotal = 0;
            angular.forEach(seats.segments, (segment) => {
                subTotal += segment.total;
            });
            return { total: subTotal, totalFormatted: '' };
        }

        /**
         * Calculate total price of all ancillaries
         */
        function calculateAllBasket (model) {
            const actualPage = localStorageService.get('actualStepFlow');
            model.total.original = model.trips ? model.trips.total.totalPrice : 0;
            if (model.trips && actualPage === 'ibpurc') {
                model.total.original = model.trips.total.original;
            }
            if (model.baggages.hasBaggage) {
                model.total.original += model.baggages.total.total;
            }
            if (model.bundle.hasBundle) {
                model.total.original += model.bundle.total.total;
            }
            if (model.seats.hasSeats) {
                model.total.original += model.seats.total.total;
            }
            if (model.insurance.hasInsurance) {
                model.total.original += model.insurance.total.total;
            }
            if (model.upgrading.hasUpgrading) {
                model.total.original += model.upgrading.total;
            }
            if (model.speqs.hasSpeqs) {
                model.total.original += model.speqs.total.total;
            }
            if (model.flexibilization.hasFlexibilization) {
                model.total.original += model.flexibilization.info.amount.price;
            }
            if (model.priorityBoarding.hasPriorityBoarding) {
                model.total.original += model.priorityBoarding.info.amount;
            }
            if (model.carbonFootprint.hasCarbonFootprint) {
                model.total.original += model.carbonFootprint.total.total;
            }
            if (model.globickTransfers.hasTransfersGlobick) {
                model.total.original += model.globickTransfers.total.total;
            }
            if (model.globickActivities.hasActivitiesGlobick) {
                model.total.original += model.globickActivities.total.total;
            }
            if (model.insuranceAllianzFusionInfo.hasInsuranceAllianzFusion) {
                model.total.original += model.insuranceAllianzFusionInfo.total.total;
            }
            if (model.othersModel.hasElements) {
                model.total.original += model.othersModel.total.total;
            }
            if (model.discountsModel.hasDiscounts) {
                model.total.original -= model.discountsModel.total;
            }
            model.total.formatted = CurrencyService.formatPrice(model.currency, model.total.original, true);
            $rootScope.$broadcast('totalBasket', model.total.formatted);
        }
        return self;
    }
}

)();
